import MixpanelLogger from '../../../../../lib/MixpanelLogger'

const isQuarterbackDraftDeputyFlow = context => context === 'pro_client_dashboard'

export const trackAddDeputyEvent = ({context, eventName, payload = {}}) => {
  if (isQuarterbackDraftDeputyFlow(context))
    return

  MixpanelLogger.track(eventName, {...payload, context})
}

export default trackAddDeputyEvent
